import GenericCreate from 'client/js/resellercp/generic_resource/create';
import { CheckboxCollectionInput, StringInput } from 'client/js/util/form_utils';
import { useResource } from 'client/js/util/rest_utils';

const Form = () => {
  const { data, component } = useResource(['roles'], '/usercp/api_keys/roles.json');

  if (component) return component;

  return (
    <>
      <StringInput name="name" label="Name (optional)" />
      <CheckboxCollectionInput name="roles" label="Rollen" required options={data.roles.map((item) => [item.name, item.name])} />
    </>
  );
};

const Page = () => (<GenericCreate namespace="usercp" resource_name="api_keys" form_component={() => (<Form />)} />);

export default Page;
